import React from "react";
import "./SectionHeading.css";

/**
 * Common SectionHeading component
 * Reusable across the site matching the editorial luxury lookbook style
 * 
 * @param {string} title - Section heading title
 * @param {string} subtitle - Section subtitle / description text
 * @param {string} subTitle - Alias for subtitle
 * @param {string} intro - Alias for subtitle
 * @param {string} content - Alias for subtitle
 * @param {string} tag - HTML heading tag ('h1' | 'h2' | 'h3' etc.), default: 'h2'
 * @param {string} as - Alias for tag
 * @param {string} className - Additional CSS class name for the wrapper
 * @param {string} titleClassName - Additional CSS class name for the title
 * @param {string} subtitleClassName - Additional CSS class name for the subtitle
 * @param {string|number} subtitleMaxWidth - Optional custom max-width for the subtitle
 * @param {object} style - Inline styles for the wrapper
 */
const SectionHeading = ({
  title,
  subtitle,
  subTitle,
  intro,
  content,
  tag,
  as,
  className = "",
  titleClassName = "",
  subtitleClassName = "",
  subtitleMaxWidth,
  style = {},
  ...rest
}) => {
  const HeadingTag = tag || as || "h2";
  const subtitleText = subtitle || subTitle || intro || content;

  return (
    <div className={`maya-section-header ${className} `} style={style} {...rest}>
      {title && (
        <HeadingTag className={`maya-section-heading ${titleClassName}`}>
          {title}
        </HeadingTag>
      )}
      {/* {subtitleText && (
        <p
          className={`maya-section-intro ${subtitleClassName}`}
          style={subtitleMaxWidth ? { maxWidth: subtitleMaxWidth } : undefined}
        >
          {subtitleText}
        </p>
      )} */}
    </div>
  );
};

export { SectionHeading, SectionHeading as SectionHeader };
export default React.memo(SectionHeading);
